export default class DomainVerificationError extends Error {
  constructor(message = '', ...args) {
    super(message, ...args)
    this.name = 'DomainVerificationError'
    this.message = message
  }
}
